import './ReportFormFieldToggle.scss';
import { FieldPath } from '@form-ts/core';
import React from 'react';
import { SwitchField } from 'src/modules/form/components/SwitchField';
import { FormError } from 'src/modules/form/types/FormError';
import { ReportFormData } from 'src/modules/report/types/ReportFormData';

type Props = {
  readonly field: FieldPath<ReportFormData, FormError, boolean>;
  readonly disabled?: boolean;
  readonly children: React.ReactNode;
};

export const ReportFormFieldToggle = ({ field, disabled, children }: Props): React.ReactElement => (
  <div className="bp-report-form-field-switch">
    <SwitchField
      disabled={disabled}
      field={field}
      valueActive={children}
      valueInactive={children}
      kind="secondary"
    />
  </div>
);
